import { SERVER_URL } from "../../Util/constants";
import {
  startRequest,
  submitRequestSuccess,
  clearRequestStatus,
  submitRequestError,
} from "Store/features/stateSlice";
import { REQUESTS } from "Util/constants";

const localRes = { token: "c37db5d4-4107-467a-88df-5865f210814c" };
const makeLoginRequest = async (dispatch, email, password) => {
  dispatch(startRequest(REQUESTS.EMAIL_PASSWORD_LOGIN));
  let response;
  try {
    response = await fetch(`${SERVER_URL}/portal/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    if (response.status === 400) {
      dispatch(
        submitRequestError({
          request: REQUESTS.EMAIL_PASSWORD_LOGIN,
          message: "That Email/Password is invalid. Try Again.",
        })
      );
    }
  } finally {
    const loginResponse = await response.json();
    dispatch(submitRequestSuccess(REQUESTS.EMAIL_PASSWORD_LOGIN));
    dispatch(clearRequestStatus(REQUESTS.EMAIL_PASSWORD_LOGIN));
    return loginResponse;
  }
};

const makeCreateAccountRequest = async (dispatch, email, password) => {
  dispatch(startRequest(REQUESTS.CREATE_ACCOUNT));
  let response;
  try {
    response = await fetch(`${SERVER_URL}/portal/account/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    dispatch(submitRequestSuccess(REQUESTS.CREATE_ACCOUNT));
  } catch (err) {
    console.log('CREATION ERR');
    
  } finally {
    dispatch(clearRequestStatus(REQUESTS.CREATE_ACCOUNT));
  }
  return await response.json();
};

const makeVerifyEmailRequest = async (dispatch, email, emailVerificationToken) => {
  dispatch(startRequest(REQUESTS.VERIFY_EMAIL));
  let response;
  try {
    response = await fetch(`${SERVER_URL}/portal/email/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ emailVerificationToken, email }),
    });
    dispatch(submitRequestSuccess(REQUESTS.VERIFY_EMAIL));
  } finally {

    setTimeout(() => {
      dispatch(clearRequestStatus(REQUESTS.VERIFY_EMAIL));
    }, 5000);
  }
  return await response.json();
}

export { makeLoginRequest, makeCreateAccountRequest, makeVerifyEmailRequest };
